var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9261 17H2.5968V9.09584L9.25945 3.31543L15.9261 9.09185V17Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00078 9.33137C1.79601 9.33194 1.59601 9.2695 1.42793 9.15253C1.25985 9.03556 1.13182 8.86972 1.06121 8.6775C0.990597 8.48528 0.980825 8.276 1.03322 8.07803C1.08561 7.88007 1.19763 7.70302 1.35408 7.5709L8.66343 1.23958C8.8442 1.08497 9.07425 1 9.31213 1C9.55001 1 9.78006 1.08497 9.96083 1.23958L17.2742 7.5709C17.3756 7.65526 17.4589 7.75918 17.5193 7.87646C17.5796 7.99374 17.6158 8.12198 17.6255 8.25353C17.6372 8.38425 17.6224 8.516 17.5819 8.64085C17.5414 8.7657 17.4761 8.88108 17.3899 8.98007C17.3049 9.08012 17.2009 9.16239 17.084 9.22217C16.967 9.28196 16.8395 9.31807 16.7086 9.32846C16.5776 9.33884 16.446 9.32329 16.3211 9.28269C16.1962 9.24208 16.0805 9.17723 15.9808 9.09185L9.31013 3.31542L2.64749 9.09584C2.46632 9.24794 2.23734 9.33133 2.00078 9.33137V9.33137Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3792 16.8603H7.38721V13.8623C7.38721 13.333 7.5975 12.8253 7.97182 12.4509C8.34614 12.0766 8.85383 11.8663 9.38321 11.8663C9.91258 11.8663 10.4203 12.0766 10.7946 12.4509C11.1689 12.8253 11.3792 13.333 11.3792 13.8623V16.8603Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.5cd59a1bc0e8028f6289a2aac7e7277b.svg";
export { ForwardRef as ReactComponent };